import { TypePolicies } from '@apollo/client'

// Poor man's deduplication of incoming items
const deduplicate = (existing: any[] = [], incoming: any[]) => {
  return [...existing, ...incoming.filter((item) => existing.every((e) => e.__ref !== item.__ref))]
}

// Prefer incoming items
const override = (_existing: any, incoming: any) => incoming

export const typePolicies: TypePolicies = {
  User: {
    fields: {
      reviews: {
        keyArgs: ['brandId', 'take', 'order']
      },
      brandReviewReactions: {
        merge: override
      }
    }
  },

  Review: {
    fields: {
      tags: {
        merge: override
      },
      reactions: {
        merge: override
      }
    }
  },

  Brand: {
    fields: {
      lists: {
        merge: override
      },
      categoryIds: {
        merge: override
      },
      categories: {
        merge: override
      },
      discountCodes: {
        merge: override
      },
      externalLinks: {
        merge: override
      },
      reviews: {
        keyArgs: false
      }
    }
  },

  BrandsResponse: {
    fields: {
      items: {
        merge: deduplicate
      },
      hasMore: {
        merge: override
      }
    }
  },

  Cart: {
    fields: {
      shippingCountries: {
        merge: override
      },
      merchants: {
        merge: override
      },
      bags: {
        merge: override
      }
    }
  },

  ReviewsResponse: {
    fields: {
      items: {
        merge: deduplicate
      },
      hasMore: {
        merge: override
      }
    }
  },

  StoriesResponse: {
    fields: {
      items: {
        merge: deduplicate
      },
      hasMore: {
        merge: override
      }
    }
  },

  Query: {
    fields: {
      contributorLeads: {
        merge: override
      },
      reviews: {
        merge: override
      },
      brandReviewReactions: {
        merge: override
      },
      review: {
        read(_, { args, toReference }) {
          return toReference({
            __typename: 'Review',
            id: args?.id
          })
        }
      },
      merchantProducts: {
        keyArgs: ['brandId'],
        merge: override
      }
    }
  },

  Mutation: {
    fields: {
      addOrRemoveBrandFromList: {
        merge: override
      },
      toggleReviewReaction: {
        merge: override
      }
    }
  },

  ReviewSummary: {
    keyFields: ['brandId']
  }
}
